import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkUpdatePartType = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkUpdatePartType
>;

export type BulkUpdatePartTypeDto = ClientInferRequest<
  typeof contract.quoteRequestLines.bulkUpdatePartType
>["body"];

export const bulkUpdatePartType = async (
  payload: BulkUpdatePartTypeDto,
): Promise<BulkUpdatePartType> => {
  const response = await api.quoteRequestLines.bulkUpdatePartType.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to bulk update part type", response.status, response.body);
};
